import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuthStatus } from './useAuthStatus';

/**
 * Layout route that gates protected surfaces. Mounts BEFORE `SignedInShell`,
 * so unauthenticated users never see the dashboard chrome — they redirect to
 * `/sign-in?next=<path>` while the route renders nothing. Preserves the
 * existing `next=` contract consumed by `SignIn`.
 */
export function RequireAuth() {
  const status = useAuthStatus();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (status !== 'unauth') return;
    const path = location.pathname + location.search;
    const next = encodeURIComponent(path);
    navigate(`/sign-in?next=${next}`, { replace: true });
  }, [status, location.pathname, location.search, navigate]);

  if (status !== 'authed') return null;
  return <Outlet />;
}
